<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 27h-1v-2a2 2 0 00-2-2v-8h.24a2 2 0 001.28-3.54l-9.24-7.7a2 2 0 00-2.56 0l-9.24 7.7A2 2 0 006.76 15H7v8a2 2 0 00-2 2v2H4a1 1 0 000 2h24a1 1 0 000-2zM6.76 13L16 5.3l9.24 7.7H6.76zM23 15v8h-2.75v-8zm-3.75 0v8H16.5v-8zM13 15h2.5v8H13v-7.82a.39.39 0 000-.18zm-1 0a.39.39 0 000 .18V23H9v-8zm13 12H7v-2h18z"/><path d="M16 11.5a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5zm0-2a.5.5 0 11-.5.5.5.5 0 01.5-.5z"/></svg>